import { Component } from '@angular/core';
import { ScrollService } from './services/scroll.service';
import { AccountService } from './services/account.service';
import {Router, NavigationEnd} from '@angular/router';
import  { environment } from '../environments/environment';
// import { GoogleTagManagerService } from 'angular-google-tag-manager';

declare var gtag;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'VeCPD';
  constructor(
    private scrollService:ScrollService,
    private _acc: AccountService,
    public _router: Router,
    // private _gtmService: GoogleTagManagerService
  ) {
    this.scrollService.setScrollTop();

    this.loadGtm(environment.gtmContainerId);

    this._router.events.subscribe(event => {

      if (event instanceof NavigationEnd) {
        gtag('config', environment.gtmKey, {'page_path':event.urlAfterRedirects});
      }

    });
  }

  private loadGtm(containerId: string): void {
    if (!containerId) return;
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=' + containerId;
    document.head.insertBefore(script, document.head.firstChild);
  }

  changeOfRoutes(){
    if(localStorage.getItem('token')){
      this._acc.getNotifications().subscribe(
        res => {}
      );
    }
  }
}
